import request from '@/utils/request'

const url = '/home/quotation/'
const api = {
  getQuotation (data) {
    return request({
      url: url + 'getQuotation',
      method: 'post',
      data
    })
  },
  doExcel (data) {
    return request({
      url: url + 'doExcel',
      method: 'post',
      data
    })
  },
  getQuotationList (data) {
    return request({
      url: url + 'getQuotationList',
      method: 'post',
      data
    })
  },
  handleDelete (data) {
    return request({
      url: url + 'handleDelete',
      method: 'post',
      data
    })
  },
  getCompany (data) {
    return request({
      url: url + 'getCompany',
      method: 'post',
      data
    })
  },
  searchMember (data) {
    return request({
      url: url + 'searchMember',
      method: 'post',
      data
    })
  },
  searchGoods (data) {
    return request({
      url: url + 'searchGoods',
      method: 'post',
      data
    })
  },
  saveQuotation (data) {
    return request({
      url: url + 'saveQuotation',
      method: 'post',
      data
    })
  },
  changeIstransaction (data) {
    return request({
      url: url + 'changeIstransaction',
      method: 'post',
      data
    })
  },
  changeBusOrder (data) {
    return request({
      url: url + 'changeBusOrder',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/quotation.js